import { gainXp } from './realms';

// Skills (功法) module
function learn(state, skill) {
  if (!skill) return ['请指定技能名称，例如 learn 炼气。'];
  if (state.skills[skill]) return [`你已掌握 ${skill}。`];
  state.skills[skill] = 1;
  return [`你开始学习 ${skill}，掌握度 1。`];
}

function listSkills(state) {
  return Object.keys(state.skills);
}

// Enhanced practice in cave mansion
function cultivate(state) {
  if (state.location !== '洞府') return ['只能在洞府中修炼。'];
  if (state.qi < 20) return ['你的气血不足，无法深入修炼。'];
  state.qi -= 20;
  const msgs = gainXp(state, 300);
  msgs.unshift('在洞府中深入修炼，消耗 20 气血，效率更高。');
  return msgs;
}

export { learn, listSkills, cultivate };
